import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class InvestorPagedLookupCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public investorName: string = "";

    public showUnauthorised: boolean = false;

    public idRegNo: string = "";

    public accountNo: string = "";

    @Attributes.Nullable()
    @Attributes.Integer()
    public investorId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Paged Lookup Criteria";
    }
}